import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, SimpleChange } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ICountry, IState } from '../interface';
import { GeneralService } from 'src/app/services/general.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonMethodService } from '../common-method.service';
import { ECallScriptForms,EUserFunctions } from '../enum';
declare var swal: any;

@Component({
    selector: 'app-invoice-setting',
    templateUrl: './invoice-setting.component.html',
    styleUrls: ['./invoice-setting.component.scss'],
    standalone: false
})

export class InvoiceSettingComponent implements OnInit {
    @Input() invoiceSettingCallScriptFields = [];
    @Input() section;
    @Output() emitSaveInvoiceCallScript = new EventEmitter();
    @Output() emitChangedScript = new EventEmitter();


    @Input() facilityInvoiceSettings;
    @Input() moduleType;
    @Input() contactInfoData;
    @Input() tenantCountryId;
    @Input() invoiceDetails;
    @Input() enableEmailInvoice = false;
    @Output() closeView: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeInvoiceView: EventEmitter<any> = new EventEmitter<any>();
    @Output() exemptTax: EventEmitter<any> = new EventEmitter<any>();
    @Output() invoiceInfo: EventEmitter<any> = new EventEmitter<any>();
    @Output() taxInfo: EventEmitter<any> = new EventEmitter<any>();
    @Input() isFromQuickstartRentUnit: boolean = false;
    invoiceSettingsForm: FormGroup;
    isCustomerModule = false;
    countryList: ICountry[];
    defaultCountry: number;
    stateList: IState[];
    taxFormDetails;
    invoiceFormDetails;
    modalRef: BsModalRef;
    emptyStateList = false;
    exemptTaxEditRight : boolean=false;
    positiveNumberPattern = '^[0-9][0-9]*$';
    alphaNumericPattern = '^[A-Za-z0-9]+';
    alphabeticPattern = '^[a-zA-Z]+';
    public PhoneNumberMask: String = '(000)000-0000';
    emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';

    public onStartfocus(args): void {
        args.selectionStart = 1;
        args.selectionEnd = 1;
    }
    constructor(private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private modalService: BsModalService,
        private facOpsDataService: FacOpsDataService,
        private commonMethodService: CommonMethodService) { }

    ngOnInit() {
        if (this.moduleType === 'customer') {
            this.isCustomerModule = true;
        }
        this.getCountries();
        this.invoiceSettingsForm = this.formBuilder.group({
            SendInvoice: [false],
            InvoicePeriods: ['', [Validators.pattern(this.positiveNumberPattern)]],
            RaiseInvoiceBeforeDays: ['', Validators.pattern(this.positiveNumberPattern)],
            EmailInvoice: [false],
            PostalInvoice: [false],
            ExemptInvoiceFee: [false],
            TaxExempt: [false],
            taxExemptForm: this.formBuilder.group({
                TaxID: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
                CompanyName: [''],
                FirstName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
                MiddleName: [''],
                LastName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
                Address: [''],
                City: [''],
                State: [''],
                ZipCode: [''],
                Country: [''],
                CellPhone: ['', [Validators.required, this.cellPhoneValidator]],
                CellPhoneDialInCode: [''],
                HomePhone: [''],
                HomePhoneDialinCode: [''],
                WorkPhone: [''],
                WorkPhoneDialinCode: [''],
                WorkPhoneExt: [''],
                Email: ['', Validators.pattern(this.emailIdsPattern)],
                Fax: [''],
                FaxDialinCode: [''],
            })

        });
        if (this.getTaxExemptService === undefined || this.getTaxExemptService === null) {
            if (this.contactInfoData) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                    CompanyName: this.contactInfoData.CompanyName,
                    FirstName: this.contactInfoData.FirstName,
                    MiddleName: this.contactInfoData.MiddleName,
                    LastName: this.contactInfoData.LastName,
                    Address: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyAddress :
                        this.contactInfoData.Address,
                    City: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyCity :
                        this.contactInfoData.City,
                    State: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyState :
                        this.contactInfoData.State ? this.contactInfoData.State.Id : '',
                    ZipCode: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyZip :
                        this.contactInfoData.Zip,
                    Country: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyCountryId :
                        this.contactInfoData.CountryId,
                    CellPhone: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyPhone :
                        this.contactInfoData.CellPhoneNumber,
                    CellPhoneDialInCode: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyPhoneCountryId :
                        this.contactInfoData.CellPhoneCountryId,
                    HomePhone: this.contactInfoData.HomePhone,
                    HomePhoneDialinCode: this.contactInfoData.HomePhoneCountryId,
                    WorkPhone: this.contactInfoData.WorkPhone,
                    WorkPhoneDialinCode: this.contactInfoData.WorkPhoneCountryId,
                    WorkPhoneExt: this.contactInfoData.WorkPhoneExtn,
                    Email: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyEmail :
                        this.contactInfoData.Email,
                    Fax: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyFax :
                        this.contactInfoData.Fax,
                    FaxDialinCode: this.contactInfoData.BusinessAccount === true ? this.contactInfoData.CompanyFaxCountryId :
                        this.contactInfoData.FaxCountryId,
                });
                this.setTaxExemptService = this.invoiceSettingsForm.get('taxExemptForm').value;
            } else {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                    State: this.tenantCountryId == 1 || this.tenantCountryId == 2 ? '' : 0,
                    Country: this.tenantCountryId,
                    CellPhoneDialInCode: this.tenantCountryId,
                    HomePhoneDialinCode: this.tenantCountryId,
                    WorkPhoneDialinCode: this.tenantCountryId,
                    FaxDialinCode: this.tenantCountryId,
                });
                this.setTaxExemptService = this.invoiceSettingsForm.get('taxExemptForm').value;
            }
        } else {
            this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                TaxID: this.getTaxExemptService.TaxIdentificationNumber,
                CompanyName: this.getTaxExemptService.CompanyName,
                FirstName: this.getTaxExemptService.FirstName,
                MiddleName: this.getTaxExemptService.MiddleName,
                LastName: this.getTaxExemptService.LastName,
                Address: this.getTaxExemptService.Address,
                City: this.getTaxExemptService.City,
                State: this.getTaxExemptService.State,
                ZipCode: this.getTaxExemptService.ZipCode,
                Country: this.getTaxExemptService.Country,
                CellPhone: this.getTaxExemptService.CellPhone,
                CellPhoneDialInCode: this.getTaxExemptService.CellPhoneDialInCode,
                HomePhone: this.getTaxExemptService.HomePhone,
                HomePhoneDialinCode: this.getTaxExemptService.HomePhoneDialinCode,
                WorkPhone: this.getTaxExemptService.WorkPhone,
                WorkPhoneDialinCode: this.getTaxExemptService.WorkPhoneDialinCode,
                WorkPhoneExt: this.getTaxExemptService.WorkPhoneExt,
                Email: this.getTaxExemptService.Email,
                Fax: this.getTaxExemptService.Fax,
                FaxDialinCode: this.getTaxExemptService.FaxDialinCode,
            });
        }
        if (this.getInvoiceSettingsService === undefined || this.getInvoiceSettingsService === null) {
            this.invoiceSettingsForm.get('InvoicePeriods').disable();
            this.invoiceSettingsForm.get('RaiseInvoiceBeforeDays').disable();
            this.invoiceSettingsForm.get('EmailInvoice').disable();
            this.invoiceSettingsForm.get('PostalInvoice').disable();
            this.invoiceSettingsForm.get('ExemptInvoiceFee').disable();
            this.invoiceSettingsForm.patchValue({ InvoicePeriods: 0, RaiseInvoiceBeforeDays: 0 });
            if (this.moduleType == 'rental' && this.enableEmailInvoice && (this.contactInfoData && ((this.contactInfoData.Email && !this.contactInfoData.BusinessAccount) || (this.contactInfoData.BusinessAccount && this.contactInfoData.CompanyEmail)))) {
                this.enableOtherFields(true);
                this.invoiceSettingsForm.patchValue({
                    SendInvoice: true,
                    EmailInvoice: true,
                });
                const invoiceFormDetails = {
                    SendInvoice: this.invoiceSettingsForm.value.SendInvoice,
                    InvoicePeriods: this.invoiceSettingsForm.value.InvoicePeriods,
                    RaiseInvoiceBeforeDays: this.invoiceSettingsForm.value.RaiseInvoiceBeforeDays,
                    EmailInvoice: this.invoiceSettingsForm.value.EmailInvoice,
                    PostalInvoice: this.invoiceSettingsForm.value.PostalInvoice,
                    ExemptInvoiceFee: this.invoiceSettingsForm.value.ExemptInvoiceFee,
                    TaxExempt: this.invoiceSettingsForm.value.TaxExempt,
                    TaxIdentificationNumber: '',
                    LeaseNo: 0,
                    FacilityId: 0
                };
                this.setInvoiceSettingsService = invoiceFormDetails;
                this.enableEmailInvoice = false;
                this.invoiceInfo.emit(invoiceFormDetails);
            }
        } else {
            this.invoiceSettingsForm.patchValue({
                SendInvoice: this.getInvoiceSettingsService.SendInvoice,
                InvoicePeriods: this.getInvoiceSettingsService.InvoicePeriods,
                RaiseInvoiceBeforeDays: this.getInvoiceSettingsService.RaiseInvoiceBeforeDays,
                EmailInvoice: this.getInvoiceSettingsService.EmailInvoice,
                PostalInvoice: this.getInvoiceSettingsService.PostalInvoice,
                ExemptInvoiceFee: this.getInvoiceSettingsService.ExemptInvoiceFee,
                TaxExempt: this.getInvoiceSettingsService.TaxExempt
            });
        }
        if (this.invoiceDetails) {
            this.invoiceSettingsForm.patchValue({
                SendInvoice: this.invoiceDetails.SendInvoice,
                InvoicePeriods: this.invoiceDetails.InvoicePeriods,
                RaiseInvoiceBeforeDays: this.invoiceDetails.RaiseInvoiceBeforeDays,
                EmailInvoice: this.invoiceDetails.EmailInvoice,
                PostalInvoice: this.invoiceDetails.PostalInvoice,
                ExemptInvoiceFee: this.invoiceDetails.ExemptInvoiceFee,
                TaxExempt: this.invoiceDetails.TaxExempt
            });
        }
        this.onCountryChange(this.tenantCountryId);
        this.invoiceSettingsForm.controls['RaiseInvoiceBeforeDays'].valueChanges.subscribe(change => {
            console.log(change); // Value inside the input field as soon as it changes
            if (change > 60) {
                this.invoiceSettingsForm.patchValue({ RaiseInvoiceBeforeDays: 60 });
            }
        });

        this.facOpsDataService.scriptIndex$.subscribe(({ section, index }) => {
            if (section !== this.section || this.facOpsDataService.onPageOpen) {
                return;
            }
            this.onScriptChange();
        });
        this.exemptTaxEditRight = this.generalService.getUserPermissionsForModule(EUserFunctions['Rental : Exempt from Tax']).EditRight;
        this.invoiceSettingsForm.get('TaxExempt')?.[this.exemptTaxEditRight ? 'enable' :'disable']();
    }

    ngOnChanges(changes: SimpleChange) {
        let invoice;
        if (changes['invoiceDetails']) {
            invoice = changes['invoiceDetails'].currentValue;
            if (invoice) {
                if (invoice.SendInvoice) {
                    this.invoiceSettingsForm.get('InvoicePeriods').enable();
                    this.invoiceSettingsForm.get('RaiseInvoiceBeforeDays').enable();
                    this.invoiceSettingsForm.get('EmailInvoice').enable();
                    this.invoiceSettingsForm.get('PostalInvoice').enable();
                    this.invoiceSettingsForm.get('ExemptInvoiceFee').enable();
                }
                this.invoiceSettingsForm.patchValue({
                    SendInvoice: invoice.SendInvoice,
                    InvoicePeriods: invoice.InvoicePeriod,
                    RaiseInvoiceBeforeDays: invoice.RaiseInvoiceBeforeDays,
                    EmailInvoice: invoice.EmailInvoice,
                    PostalInvoice: invoice.PostalInvoice,
                    ExemptInvoiceFee: invoice.ExemptFromInvoiceFee,
                    TaxExempt: invoice.TaxExempt
                });
            }
        }
        if (this.isFromQuickstartRentUnit && (changes['enableEmailInvoice']) && this.enableEmailInvoice && this.moduleType == 'rental' && this.enableEmailInvoice) {
            this.formInitialisationForQuickProspect();
        }
    }

    formInitialisationForQuickProspect() {
        if (this.getInvoiceSettingsService === undefined || this.getInvoiceSettingsService === null) {
            this.enableOtherFields(true);
            this.invoiceSettingsForm.patchValue({
                SendInvoice: true,
                EmailInvoice: true,
            });
            const invoiceFormDetails = {
                SendInvoice: this.invoiceSettingsForm.value.SendInvoice,
                InvoicePeriods: this.invoiceSettingsForm.value.InvoicePeriods,
                RaiseInvoiceBeforeDays: this.invoiceSettingsForm.value.RaiseInvoiceBeforeDays,
                EmailInvoice: this.invoiceSettingsForm.value.EmailInvoice,
                PostalInvoice: this.invoiceSettingsForm.value.PostalInvoice,
                ExemptInvoiceFee: this.invoiceSettingsForm.value.ExemptInvoiceFee,
                TaxExempt: this.invoiceSettingsForm.value.TaxExempt,
                TaxIdentificationNumber: '',
                LeaseNo: 0,
                FacilityId: 0
            };
            this.setInvoiceSettingsService = invoiceFormDetails;
            this.enableEmailInvoice = false;
            this.invoiceInfo.emit(invoiceFormDetails);
        }
    }

    getCountries() {
        this.generalService.getCountries().subscribe((response: ICountry[]) => {
            this.countryList = response;
        });
    }

    onCountryChange(obj) {
        if (obj == 1 || obj == 2) {
            this.emptyStateList = false;
            if (this.invoiceSettingsForm.get('taxExemptForm.Country').value == obj && this.invoiceSettingsForm.get('taxExemptForm.State').value) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ State: this.invoiceSettingsForm.get('taxExemptForm.State').value });
            } else {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ State: '' });
            }
            this.invoiceSettingsForm.get('taxExemptForm.State').enable();
            this.getCountry(obj);
        } else {
            this.emptyStateList = true;
            this.stateList = [];
            this.invoiceSettingsForm.get('taxExemptForm').patchValue({ State: '0' });
            this.invoiceSettingsForm.get('taxExemptForm.State').disable();

            if (!this.invoiceSettingsForm.get('taxExemptForm.CellPhoneDialInCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ CellPhoneDialInCode: obj });
            }
            if (!this.invoiceSettingsForm.get('taxExemptForm.HomePhoneDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ HomePhoneDialinCode: obj });
            }
            if (!this.invoiceSettingsForm.get('taxExemptForm.WorkPhoneDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ WorkPhoneDialinCode: obj });
            }
            if (!this.invoiceSettingsForm.get('taxExemptForm.FaxDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ FaxDialinCode: obj });
            }
        }
    }

    getStates(id) {
        this.generalService.getStates(id).subscribe((response: IState[]) => {
            this.stateList = response;
            if (this.contactInfoData) {
                if (id == 1 || id == 2) {
                    if ((!this.invoiceSettingsForm.get('taxExemptForm.State').value || this.invoiceSettingsForm.get('taxExemptForm.State').value == 0)) {
                        this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                            State: this.contactInfoData.State
                        });
                    }
                } else {
                    this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                        State: '0'
                    });
                }
            } else {
                if ((!this.invoiceSettingsForm.get('taxExemptForm.State').value || this.invoiceSettingsForm.get('taxExemptForm.State').value == 0)) {
                    this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                        State: id == 1 || id == 2 ? '' : '0'
                    });
                }
            }
        });
    }

    getCountry(id) {
        this.generalService.getCountry(id).subscribe((response: ICountry) => {
            this.defaultCountry = response.Id;
            this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                Country: this.defaultCountry,
            });
            this.getStates(response.Id);
            if (!this.invoiceSettingsForm.get('taxExemptForm.CellPhoneDialInCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ CellPhoneDialInCode: response.Id });
            } else { }
            if (!this.invoiceSettingsForm.get('taxExemptForm.HomePhoneDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ HomePhoneDialinCode: response.Id });
            } else { }
            if (!this.invoiceSettingsForm.get('taxExemptForm.WorkPhoneDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ WorkPhoneDialinCode: response.Id });
            } else { }
            if (!this.invoiceSettingsForm.get('taxExemptForm.FaxDialinCode').dirty) {
                this.invoiceSettingsForm.get('taxExemptForm').patchValue({ FaxDialinCode: response.Id });
            } else { }
        });
    }

    enableOtherFields(eve) {
        if (eve) {
            this.invoiceSettingsForm.get('SendInvoice').markAsTouched();
            this.invoiceSettingsForm.get('SendInvoice').markAsDirty();
            this.invoiceSettingsForm.get('InvoicePeriods').enable();
            this.invoiceSettingsForm.get('RaiseInvoiceBeforeDays').enable();
            this.invoiceSettingsForm.get('EmailInvoice').enable();
            this.invoiceSettingsForm.get('PostalInvoice').enable();
            this.invoiceSettingsForm.get('ExemptInvoiceFee').enable();
            if (this.facilityInvoiceSettings) {
                this.invoiceSettingsForm.patchValue({
                    InvoicePeriods: 1,
                    RaiseInvoiceBeforeDays: this.facilityInvoiceSettings.InvoiceBeforeDays > 0 ? this.facilityInvoiceSettings.InvoiceBeforeDays : 1
                });
            } else {
                this.invoiceSettingsForm.patchValue({ InvoicePeriods: 1, RaiseInvoiceBeforeDays: 1 });
            }
        } else {
            this.invoiceSettingsForm.get('SendInvoice').markAsTouched();
            this.invoiceSettingsForm.get('SendInvoice').markAsDirty();
            this.invoiceSettingsForm.get('InvoicePeriods').disable();
            this.invoiceSettingsForm.get('RaiseInvoiceBeforeDays').disable();
            this.invoiceSettingsForm.get('EmailInvoice').disable();
            this.invoiceSettingsForm.get('PostalInvoice').disable();
            this.invoiceSettingsForm.get('ExemptInvoiceFee').disable();
            this.invoiceSettingsForm.patchValue({
                InvoicePeriods: 0,
                RaiseInvoiceBeforeDays: 0,
                EmailInvoice: false,
                PostalInvoice: false,
                ExemptInvoiceFee: false
            });
        }
    }

    validateInvoicePeriods(number) {
        if (number !== '') {
            if (number < 1) {
                this.invoiceSettingsForm.patchValue({ InvoicePeriods: 1 });
            }
        }
    }

    validateRaiseInvoiceBeforeDays(number) {
        if (number !== '') {
            if (number < 1) {
                this.invoiceSettingsForm.patchValue({ RaiseInvoiceBeforeDays: 1 });
            }
        }
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) || event.target.value.length === 2) {
            return false;
        } else if (event.target.value === '' && charCode === 48) {
            return false;
        }
        return true;
    }

    onPaste(event) {
        const pastedText = event.clipboardData.getData('text');
        let regexp = new RegExp('^[0-9]*$');
        return regexp.test(pastedText);
    }

    onEmailValidate(template: TemplateRef<any>, eve) {
        if (this.isCustomerModule === true) {

        } else {
            if (this.contactInfoData.Email === '') {
                this.openModal(template);
            }
        }
    }

    onRaiseBeforeChange(number) {
        if (number > 60) { this.invoiceSettingsForm.patchValue({ RaiseInvoiceBeforeDays: 60 }); }
    }

    canceltaxExemptForm(template: TemplateRef<any>) {
        if (this.invoiceSettingsForm.get('taxExemptForm').dirty === true &&
            this.invoiceSettingsForm.get('taxExemptForm').touched === true) {
            this.openModal(template);
        } else {
            this.invoiceSettingsForm.patchValue({ TaxExempt: false });
            this.invoiceSettingsForm.get('taxExemptForm').markAsUntouched();
        }
    }

    onCancelTaxForm() {
        this.invoiceSettingsForm.get('taxExemptForm').markAsUntouched();
        this.invoiceSettingsForm.controls['taxExemptForm'].markAsPristine();
        this.invoiceSettingsForm.get('taxExemptForm').reset();
        this.invoiceSettingsForm.get('taxExemptForm').markAsPristine();
        this.invoiceSettingsForm.get('taxExemptForm').patchValue({
            Country: '',
        });
        this.invoiceSettingsForm.get('taxExemptForm.CellPhone').markAsPristine();
        this.invoiceSettingsForm.get('taxExemptForm.CellPhone').markAsUntouched();
        this.invoiceSettingsForm.patchValue({ TaxExempt: false });
        this.modalRef.hide();
    }

    taxExemptFormSubmit() {
        this.taxFormDetails = {
            TaxIdentificationNumber: this.invoiceSettingsForm.get('taxExemptForm').value.TaxID,
            CompanyName: this.invoiceSettingsForm.get('taxExemptForm').value.CompanyName,
            FirstName: this.invoiceSettingsForm.get('taxExemptForm').value.FirstName,
            MiddleName: this.invoiceSettingsForm.get('taxExemptForm').value.MiddleName,
            LastName: this.invoiceSettingsForm.get('taxExemptForm').value.LastName,
            Address: this.invoiceSettingsForm.get('taxExemptForm').value.Address,
            City: this.invoiceSettingsForm.get('taxExemptForm').value.City,
            State: this.invoiceSettingsForm.get('taxExemptForm').value.State,
            ZipCode: this.invoiceSettingsForm.get('taxExemptForm').value.ZipCode,
            Country: this.invoiceSettingsForm.get('taxExemptForm').value.Country,
            CellPhone: this.invoiceSettingsForm.get('taxExemptForm').value.CellPhone,
            CellPhoneDialInCode: this.invoiceSettingsForm.get('taxExemptForm').value.CellPhoneDialInCode,
            HomePhone: this.invoiceSettingsForm.get('taxExemptForm').value.HomePhone,
            HomePhoneDialinCode: this.invoiceSettingsForm.get('taxExemptForm').value.HomePhoneDialinCode,
            WorkPhone: this.invoiceSettingsForm.get('taxExemptForm').value.WorkPhone,
            WorkPhoneDialinCode: this.invoiceSettingsForm.get('taxExemptForm').value.WorkPhoneDialinCode,
            WorkPhoneExt: this.invoiceSettingsForm.get('taxExemptForm').value.WorkPhoneExt,
            Email: this.invoiceSettingsForm.get('taxExemptForm').value.Email,
            Fax: this.invoiceSettingsForm.get('taxExemptForm').value.Fax,
            FaxDialinCode: this.invoiceSettingsForm.get('taxExemptForm').value.FaxDialinCode,
        };
        this.setTaxExemptService = this.taxFormDetails;
        this.taxInfo.emit(this.taxFormDetails);
    }

    isDisabled() {
        if (this.invoiceSettingsForm.pristine && this.invoiceSettingsForm.untouched) { return true; } else
            if (this.invoiceSettingsForm.get('SendInvoice').value === true &&
                (this.invoiceSettingsForm.get('InvoicePeriods').value === null ||
                    this.invoiceSettingsForm.get('RaiseInvoiceBeforeDays').value === null)) {
                return true;
            } else { return false; }
    }

    onTaxExepmtChecked() {
        this.invoiceSettingsForm.get('taxExemptForm.CellPhone').setErrors(null);
        if (this.getTaxExemptService) {
            this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                TaxID: this.getTaxExemptService.TaxIdentificationNumber,
                CompanyName: this.getTaxExemptService.CompanyName,
                FirstName: this.getTaxExemptService.FirstName,
                MiddleName: this.getTaxExemptService.MiddleName,
                LastName: this.getTaxExemptService.LastName,
                Address: this.getTaxExemptService.Address,
                City: this.getTaxExemptService.City,
                State: this.getTaxExemptService.Country == 1 || this.getTaxExemptService.Country == 2 ? this.getTaxExemptService.State : '0',
                ZipCode: this.getTaxExemptService.ZipCode,
                Country: this.getTaxExemptService.Country,
                CellPhone: this.getTaxExemptService.CellPhone,
                CellPhoneDialInCode: this.getTaxExemptService.CellPhoneDialInCode,
                HomePhone: this.getTaxExemptService.HomePhone,
                HomePhoneDialinCode: this.getTaxExemptService.HomePhoneDialinCode,
                WorkPhone: this.getTaxExemptService.WorkPhone,
                WorkPhoneDialinCode: this.getTaxExemptService.WorkPhoneDialinCode,
                WorkPhoneExt: this.getTaxExemptService.WorkPhoneExt,
                Email: this.getTaxExemptService.Email,
                Fax: this.getTaxExemptService.Fax,
                FaxDialinCode: this.getTaxExemptService.FaxDialinCode,
            });
            this.onCountryChange(this.invoiceSettingsForm.get('taxExemptForm.Country').value);
        } else {
            this.invoiceSettingsForm.get('taxExemptForm').patchValue({
                Country: 0
            });
        }
    }

    onTaxExepmtUnChecked() {
        if (this.isCustomerModule === true) {
            this.exemptTax.emit(false);
        }
    }

    loadInvoiceData() {
        this.invoiceFormDetails = {
            SendInvoice: this.invoiceSettingsForm.value.SendInvoice,
            InvoicePeriods: this.invoiceSettingsForm.value.InvoicePeriods,
            RaiseInvoiceBeforeDays: this.invoiceSettingsForm.value.RaiseInvoiceBeforeDays,
            EmailInvoice: this.invoiceSettingsForm.value.EmailInvoice,
            PostalInvoice: this.invoiceSettingsForm.value.PostalInvoice,
            ExemptInvoiceFee: this.invoiceSettingsForm.value.ExemptInvoiceFee,
            TaxExempt: this.invoiceSettingsForm.value.TaxExempt,
            TaxIdentificationNumber: '',
            LeaseNo: 0,
            FacilityId: 0
        };
        this.setInvoiceSettingsService = this.invoiceFormDetails;
        this.enableEmailInvoice = false;
        this.invoiceInfo.emit(this.invoiceFormDetails);
    }

    selectPostalOrEmail() {
        swal({
            text: 'Please select either Email Invoice or Postal Invoice',
            showCancelButton: false,
        });
    }

    onSaveInvoice() {
        if (this.invoiceSettingsForm.value.SendInvoice === true) {
            if (this.invoiceSettingsForm.value.EmailInvoice === false && this.invoiceSettingsForm.value.PostalInvoice === false) {
                this.selectPostalOrEmail();
            } else {
                this.loadInvoiceData();

                this.closeView.emit(true);
                this.invoiceSettingsForm.markAsUntouched();
            }
        } else {
            this.loadInvoiceData();
            this.closeView.emit(true);
            this.invoiceSettingsForm.markAsUntouched();
        }
        if (this.invoiceSettingsForm.value.TaxExempt === true) {
            this.exemptTax.emit(true);
        } else {
            this.exemptTax.emit(false);
        }
        this.invoiceSettingsForm.markAsUntouched();
    }

    cancelInvoiceModal(template: TemplateRef<any>) {
        if (this.invoiceSettingsForm.dirty === true) {
            this.openModal(template);
        } else {
            this.closeInvoiceView.emit(true);
            if (this.getInvoiceSettingsService) {
                this.invoiceSettingsForm.patchValue({
                    SendInvoice: this.getInvoiceSettingsService.SendInvoice,
                    InvoicePeriods: this.getInvoiceSettingsService.InvoicePeriods,
                    RaiseInvoiceBeforeDays: this.getInvoiceSettingsService.RaiseInvoiceBeforeDays,
                    EmailInvoice: this.getInvoiceSettingsService.EmailInvoice,
                    PostalInvoice: this.getInvoiceSettingsService.PostalInvoice,
                    ExemptInvoiceFee: this.getInvoiceSettingsService.ExemptInvoiceFee,
                    TaxExempt: this.getInvoiceSettingsService.TaxExempt
                });
            }
        }
    }

    onCancelInvoice() {
        this.closeInvoiceView.emit(true);
        this.modalRef.hide();
        if (this.getInvoiceSettingsService) {
            this.invoiceSettingsForm.patchValue({
                SendInvoice: this.getInvoiceSettingsService.SendInvoice,
                InvoicePeriods: this.getInvoiceSettingsService.InvoicePeriods,
                RaiseInvoiceBeforeDays: this.getInvoiceSettingsService.RaiseInvoiceBeforeDays,
                EmailInvoice: this.getInvoiceSettingsService.EmailInvoice,
                PostalInvoice: this.getInvoiceSettingsService.PostalInvoice,
                ExemptInvoiceFee: this.getInvoiceSettingsService.ExemptInvoiceFee,
                TaxExempt: this.getInvoiceSettingsService.TaxExempt
            });
        }
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }

    get getInvoiceSettingsService() {
        return this.facOpsDataService.invoiceSettings;
    }
    set setInvoiceSettingsService(value) {
        this.facOpsDataService.invoiceSettings = value;
    }

    get getTaxExemptService() {
        return this.facOpsDataService.taxExemptInfo;
    }
    set setTaxExemptService(value) {
        this.facOpsDataService.taxExemptInfo = value;
    }

    public cellPhoneValidator(control: FormControl) {
        if ((control.value !== '') && (control.value !== null) && (control.value !== undefined)) {
            const isWhitespace = (control.value).trim().length < 10;
            const isValid = !isWhitespace;

            return isValid ? null : { 'lessThanTen': true };
        }
    }

    makeAsDirty() {
        if (this.invoiceSettingsForm.get('taxExemptForm.CellPhone').value == '') {
            this.invoiceSettingsForm.get('taxExemptForm.CellPhone').setErrors({
                required: true
            });
        }
        this.invoiceSettingsForm.get('taxExemptForm.CellPhone').markAsDirty();
    }

    alphaNumerics(event) {
        let k = this.commonMethodService.omit_special_char(event.charCode);
        return k;
    }

    onScriptChange() {
        let script = this.facOpsDataService.getScript(this.section);
        if (!script || !script.FormId || script.FormId == ECallScriptForms['Prospects: Rental: Rent Unit: Invoice Setting']
            || (script.firstTimeCalled && !script.buttonNavigate)) {
            return;
        }
        script.firstTimeCalled = true;
        if (!this.isDisabled()) {
            if (this.invoiceSettingsForm.value.SendInvoice) {
                if (this.invoiceSettingsForm.value.EmailInvoice || this.invoiceSettingsForm.value.PostalInvoice) {
                    this.loadInvoiceData();
                    this.emitSaveInvoiceCallScript.emit(true);
                }
            } else {
                this.loadInvoiceData();
                this.emitSaveInvoiceCallScript.emit(true);
            }
            if (this.invoiceSettingsForm.value.TaxExempt) {
                this.exemptTax.emit(true);
            } else {
                this.exemptTax.emit(false);
            }
            this.invoiceSettingsForm.markAsUntouched();
        }
        this.emitChangedScript.emit(script);
    }
}
